import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CurrencyContext } from './currency';
import { useCurrencyContext } from './currency/hook';
import { DialogContext } from './dialog';
import { useDialogContext } from './dialog/hook';
import { ExternalTranslationsContext } from './external-translations';
import { useExternalTranslationsContext } from './external-translations/hook';
import { LoadingContext } from './loading';
import { useLoadingContext } from './loading/hook';
import { NavHistoryContext } from './nav-history';
import { useNavHistoryContext } from './nav-history/hook';
import { SettingsContext } from './settings';
import { useSettingsContext } from './settings/hook';
import { TooltipContext } from './tooltip';
import { useTooltipContext } from './tooltip/hook';
import { UserContext } from './user';
import { useUserContext } from './user/hook';
export default function ContextProvider(_a) {
    var children = _a.children;
    var loadingContextValue = useLoadingContext();
    var dialogContextValue = useDialogContext();
    var tooltipContextValue = useTooltipContext();
    var currencyContextValue = useCurrencyContext();
    var userContextValue = useUserContext();
    var settingsContextValue = useSettingsContext();
    var navHistoryContextValue = useNavHistoryContext();
    var externalTranslationsContextValue = useExternalTranslationsContext();
    return (_jsx(LoadingContext.Provider, { value: loadingContextValue, children: _jsx(DialogContext.Provider, { value: dialogContextValue, children: _jsx(TooltipContext.Provider, { value: tooltipContextValue, children: _jsx(UserContext.Provider, { value: userContextValue, children: _jsx(CurrencyContext.Provider, { value: currencyContextValue, children: _jsx(SettingsContext.Provider, { value: settingsContextValue, children: _jsx(NavHistoryContext.Provider, { value: navHistoryContextValue, children: _jsx(ExternalTranslationsContext.Provider, { value: externalTranslationsContextValue, children: children }) }) }) }) }) }) }) }));
}
